import React from 'react';
import ServiceHistoryTable from './ServiceHistoryTable';
import ExpandableText from '../common/ExpandableText';
import { formatPhoneNumber } from '../../helpers/phoneFormatter';

const renderExpandableCell = (params) => {
    return (
        <ExpandableText
            text={params.value || ''}
            width={params.colDef.computedWidth}
            isHeader={false}
        />
    );
};

const renderExpandableHeader = (params) => {
    return (
        <ExpandableText
            text={params.colDef.headerName}
            width={params.colDef.computedWidth}
            isHeader={true}
        />
    );
};

const columns = [
    {
        headerName: 'Customer Name',
        field: 'customerName',
        headerAlign: 'center',
        align: 'center',
        flex: 1,
        sortable: false,
        renderCell: renderExpandableCell,
        renderHeader: renderExpandableHeader,
    },
    {
        headerName: 'Vehicle Year/Make/Model',
        headerAlign: 'center',
        align: 'center',
        field: 'yearMakeModel',
        flex: 1.5,
        sortable: false,
        renderCell: renderExpandableCell,
        renderHeader: renderExpandableHeader,
    },
    {
        headerName: 'License Plate',
        headerAlign: 'center',
        align: 'center',
        field: 'licensePlate',
        flex: 1,
        sortable: false,
        renderCell: renderExpandableCell,
        renderHeader: renderExpandableHeader,
    },
    {
        headerName: 'State',
        headerAlign: 'center',
        align: 'center',
        field: 'state',
        flex: 0.7,
        sortable: false,
        renderCell: renderExpandableCell,
        renderHeader: renderExpandableHeader,
    },
    {
        headerName: 'Phone',
        field: 'phone',
        headerAlign: 'center',
        align: 'center',
        flex: 1,
        sortable: false,
        renderCell: (params) => renderExpandableCell(formatPhoneNumber(params)),
        renderHeader: renderExpandableHeader,
    },
    {
        field: 'email',
        headerName: 'Email',
        headerAlign: 'center',
        align: 'center',
        flex: 1,
        sortable: false,
        renderCell: renderExpandableCell,
        renderHeader: renderExpandableHeader,
    },
];

const SingleVehicleTable = ({ vehicleData }) => {
    return (
        <div className="NBA-Data-Grid">
            <ServiceHistoryTable
                columns={columns}
                data={[vehicleData]}
                disableRowSelectionOnClick
                sx= {{"& .MuiDataGrid-row:hover": {backgroundColor: "transparent"}}}
            />
        </div>
    );
};

export default SingleVehicleTable;
